
//  useFormattedDate, useFormattedEsDate
import { ArtworkDto, EsArtworkDto } from "@slks/core";
import { computed, defineComponent, PropType } from "vue";

export default defineComponent({
    name: "TitleYearLabelForDetail",
    props: {
        artwork: {
            type: Object as PropType<EsArtworkDto | ArtworkDto>,
            required: true,
        },
    },
    setup(props) {
        const title = computed(() => {
            if (!props.artwork) return "";
            return props.artwork?.title || "";
        });

        // const { formattedDate } = useFormattedDate((props.artwork as ArtworkDto)?.productionDate, "year", false);
        // const { formattedEsDate } = useFormattedEsDate(
        //     (props.artwork as EsArtworkDto)?.productionStartDate,
        //     (props.artwork as EsArtworkDto)?.productionEndDate,
        //     "year",
        //     false,
        //     false
        // );
        const creatorsDates = (index: number) => {
            const birthDate = (props.artwork as EsArtworkDto)?.creatorsBirthDates[index];
            const deathDate = (props.artwork as EsArtworkDto)?.creatorsDeathDates[index];

            const extractYear = (date: string) => {
                const match = date && date.match(/\d{4}/);
                return match ? parseInt(match[0], 10) : null;
            };

            const startYear = extractYear(birthDate);
            const endYear = extractYear(deathDate);

            if (startYear && endYear) {
                return startYear === endYear ? `(${startYear})` : `(${startYear}-${endYear})`;
            } else if (startYear) {
                return `(${startYear})`;
            } else if (endYear) {
                return `(${endYear})`;
            } else {
                return "";
            }
        };

        const year = computed(() => {
            const startYear = (props.artwork as EsArtworkDto)?.productionStartDate
                ? new Date((props.artwork as EsArtworkDto).productionStartDate).getFullYear()
                : null;
            const endYear = (props.artwork as EsArtworkDto)?.productionEndDate
                ? new Date((props.artwork as EsArtworkDto).productionEndDate).getFullYear()
                : null;

            if (startYear && endYear) {
                return startYear == endYear ? `${startYear}` : `${startYear} - ${endYear}`;
            } else if (startYear) {
                return `${startYear}`;
            } else if (endYear) {
                return `${endYear}`;
            } else {
                return "";
            }
        });
        const yearObject = computed(() => {
            const parseYear = (yearString: string | null): number | null => {
                if (!yearString) return null;
                const year = parseInt(yearString, 10);
                return isNaN(year) ? null : year;
            };

            const startYear = parseYear((props.artwork as EsArtworkDto)?.productionStartString || null);
            const endYear = parseYear((props.artwork as EsArtworkDto)?.productionEndString || null);

            const formatYear = (year: number | null, isSingle = false): string => {
                if (year === null) return "";
                if (year === 0) return "0";
                return year > 0 ? (isSingle ? `${year}` : `${year} e.kr.`) : `${Math.abs(year)} f.kr.`;
            };

            if (startYear !== null && endYear !== null) {
                if (startYear === endYear) {
                    return formatYear(startYear, true);
                }

                if (startYear > 0 && endYear > 0) {
                    return `${startYear}-${endYear}`;
                }

                if (startYear < 0 && endYear < 0) {
                    return `${Math.abs(startYear)}-${Math.abs(endYear)} f.kr.`;
                }

                if (startYear < 0 && endYear > 0) {
                    return `${Math.abs(startYear)} f.kr.-${endYear} e.kr.`;
                }

                if (startYear > 0 && endYear < 0) {
                    return `${startYear} e.kr.-${Math.abs(endYear)} f.kr.`;
                }

                if (startYear === 0 || endYear === 0) {
                    return `${formatYear(startYear)}-${formatYear(endYear)}`;
                }
            } else if (startYear !== null) {
                return formatYear(startYear, true);
            } else if (endYear !== null) {
                return formatYear(endYear, true);
            }

            return "";
        });

        const museum = computed(() => {
            return (props.artwork as EsArtworkDto)?.museum || "";
        });

        const artist = computed(() => {
            return (props.artwork as EsArtworkDto)?.creatorsNames || [];
        });
        const formattedArtists = computed(() => {
            return (
                (props.artwork as EsArtworkDto)?.creatorsNames?.map((name) => {
                    const parts = name.split(",").map((part) => part.trim());
                    return parts.length === 2 ? `${parts[1]} ${parts[0]}` : name;
                }) || []
            );
        });
        const objectTemplate = computed(() => {
            return (props.artwork as EsArtworkDto)?.objectTemplate || "";
        });

        const creatorsBirthDates = computed(() => {
            return (props.artwork as EsArtworkDto)?.creatorsBirthDates || [];
        });

        const creatorsDeathDates = computed(() => {
            return (props.artwork as EsArtworkDto)?.creatorsDeathDates || [];
        });

        return {
            title,
            year,
            museum,
            artist,
            objectTemplate,
            creatorsBirthDates,
            creatorsDeathDates,
            formattedArtists,
            creatorsDates,
            yearObject,
        };
    },
});
